export default __webpack_public_path__ + "static/bach-9fef11ab700fe16b8b9da3a59942e0e7.jpg";